export default "__VITE_ASSET__CXJnVx5L__"